export default function debounce (callback, wait, immediate) {
  if (wait === true || wait === false) {
    immediate = wait
    wait = undefined
  }

  let timeout
  let last
  let result
  let args
  let context

  function invoke () {
    result = callback.apply(context, args)
    context = args = null
  }

  function later () {
    const delta = Date.now() - last

    if (wait !== undefined && delta >= 0 && delta < wait) {
      timeout = setTimeout(later, wait - delta)
    } else {
      timeout = null

      if (!immediate) {
        invoke()
      }
    }
  }

  return function debounced () {
    context = this
    args = arguments
    last = Date.now()

    if (!timeout) {
      if (wait === undefined) {
        timeout = requestAnimationFrame(later)
      } else {
        timeout = setTimeout(later, wait)
      }

      if (immediate) {
        invoke()
      }
    }

    return result
  }
}
